(function() {
  angular.module('forgotPassword')
    .service('loginUserService', function() {
      //This is our initial value, don't ever let anyone touch it (never return this object)
      let loginModelInitial = { challengeResponses: [{}, {}, {}]};
      let loginModel = angular.copy(loginModelInitial);
      return {
        loginModel: function(_loginModel) {
          if (_loginModel !== undefined) {
            /* Merge whatever is passed in into an empty object and then merge in the
            object with the challengeResponses */
            loginModel = _.merge({}, _loginModel, loginModelInitial);
          }
          return loginModel;
        },
        init: function() {
          loginModel = angular.copy(loginModelInitial);
        }
      };
    });
})();
